import { AccademicYearContent } from "../../components/configuration";

export default function AccademicYear() {
  return (
    <>
      <AccademicYearContent />
    </>
  );
}
